import { render, staticRenderFns } from "./dishonour.vue?vue&type=template&id=79788a50&scoped=true&"
import script from "./dishonour.vue?vue&type=script&lang=js&"
export * from "./dishonour.vue?vue&type=script&lang=js&"
import style0 from "./dishonour.vue?vue&type=style&index=0&id=79788a50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79788a50",
  null
  
)

export default component.exports